import { styled } from '@mui/material/styles';

export const TextAndSwitchContainer = styled('li')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    width: '100%',
}));